module.exports = __webpack_public_path__ + "img/icon_category.7cf5cd6d.svg";